import {
    Container,
    Grid,
    makeStyles,
    Card,
    Accordion,
    AccordionSummary,
    Typography,
    AccordionDetails,
    CardContent,
    TablePagination,
    SvgIcon,
    Chip,
    Tooltip
} from '@material-ui/core';
import { AutocompleteForm, Header, Page, Tabla } from 'components';
import React, { useEffect, useState } from 'react';
import { ReactComponent as cdesde } from 'assets/finicio_ico.svg';
import { ReactComponent as chasta } from 'assets/ffin_ico.svg';
import serviciosCatalogo from 'utils/serviciosCatalogo';
import MenuSistemas from './Components/MenuSistemas';
import { ExpandMore } from '@material-ui/icons';
import serviciosReportes from 'utils/serviciosReportes';
import NumberFormat from 'react-number-format';

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    containerRequerimientos: {
        paddingTop: theme.spacing(3)
    },
    containerSistemas: {
        maxHeight: '75vh',
        overflow: 'auto'
    },
    des: {
        backgroundColor: theme.palette.alert.main
    },
    fin: {
        backgroundColor: theme.palette.finish.main
    }
}));
const TareasXrequerimientos = ({}) => {
    const classes = useStyles();
    const [mensaje, setMensaje] = useState({ open: false });
    const [cargando, setCargando] = useState(false);
    const [btnTdxs,setBtnTdxs]= useState(false);
    const [campos, setCampos] = useState({ sistema: null, estatus: null, gerencia: null });
    const cerrarMensaje = () => setMensaje({ ...mensaje, open: false });
    const [catalogos, setCatalogos] = useState({
        sistemas: [],
        estatusSolicitud: [],
        gerencias: []
    });
    const [paginacion, setPaginacion] = useState({ rowPage: 6, page: 0 });
    const [solicitudSeleccionada, setExpanded] = useState(null);
    const getGerencias = solicitudes =>
        solicitudes.reduce((gerencias, solicitud) => {
            if (!gerencias.find(gerencia => gerencia.responsable == solicitud.responsable))
                return [...gerencias, { responsable: solicitud.responsable, nresponsable: solicitud.nresponsable }];
            return gerencias;
        }, []);
    const cambioProyectoSeleccionado = sistema => {
        if (sistema) {
            if (sistema.idproyecto != campos.sistema?.idproyecto)
                // buscar en DB
                serviciosReportes.getsolporsistema(
                    res => {
                        setCatalogos({ ...catalogos });
                        setCampos({
                            ...campos,
                            gerencia: null,
                            sistema: {
                                ...sistema,
                                requerimientos: res
                            }
                        });
                    },
                    setCargando,
                    { estatus: campos.estatus, sistema: sistema }
                );
        } else setCampos({ ...campos, sistema: null });
    };
    // requerimientosDefault.filter(
    //   (requerimiento) => requerimiento.idproyecto == sistema.idproyecto
    // ),
    const cambioEstatusSeleccionado = estatus => {
        if (estatus && campos.sistema) {
            // buscar en DB
            serviciosReportes.getsolporsistema(
                res => {
                    setCampos({
                        ...campos,
                        estatus,
                        gerencia: null,
                        sistema: {
                            ...campos.sistema,
                            requerimientos: res
                        }
                    });
                },
                setCargando,
                { estatus: estatus, sistema: campos.sistema }
            );
        } else
            setCampos({
                ...campos,
                estatus,
                gerencia: null,
                sistema: campos.sistema ? { ...campos.sistema, requerimientos: [] } : null
            });
    };
    const handleChange = panel => (event, isExpanded) => {
        if (isExpanded) {
            serviciosReportes.getTareaxSolicitud(
                res => {
                    panel.tareas = res.tareas || [];
                    setCampos(campos);
                    setExpanded({ ...panel, tareas: res.tareas || [] });
                },
                setCargando,
                { idsolicitud: panel.idsolicitud }
            );
        } else setExpanded(null);
    };
    const columns = [
        { label: 'Tipo', name: 'tipo' },
        { label: 'Estatus', name: 'nestatus' },
        { label: 'titulo', name: 'titulo' },
        { label: 'Inicio', name: 'finicio' },
        { label: 'Término', name: 'ffin' }
    ];
    const format = date => {
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        const formattedDate = new Date(date + 'T12:00:00').toLocaleDateString('es-MX', options);
        const [d, m, y] = formattedDate.split('/');
        return `${d}-${m}-${y}`;
    };
    useEffect(() => {
        serviciosCatalogo.sistemasAll(
            data => {
                setCampos({ ...campos, estatus: estatusSolicitud[0] });
                setCatalogos({
                    sistemas: data.proyectos.filter(p => [3, 9].includes(p.idestatus) && p.nproyecto != "TODOS"),
                    estatusSolicitud: [...estatusSolicitud, { id: null, nestatus: 'TODAS' }]
                });
                if(data.todos)
                    setBtnTdxs(true);
            },
            setCargando,
            {}
        );
    }, []);
    useEffect(() => {
        setPaginacion({ ...paginacion, page: 0 });
        setExpanded(null);
    }, [campos]);
    const solicitudesFiltradas =
        campos.sistema?.requerimientos?.filter(solicitud => !campos.gerencia || campos.gerencia.responsable == solicitud.responsable) || [];
    return (
        <Page title="Panel de solicitudes" className={classes.root} mensaje={{ ...mensaje, cerrar: cerrarMensaje }} cargando={cargando}>
            <Container maxWidth={false}>
                <Header
                    subtitle={
                        <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                            <Grid item>Tareas por solicitudes</Grid>
                            <Grid item xs={5} container spacing={2} alignContent="center" ai>
                                <Grid item xs={6}>
                                    <AutocompleteForm
                                        label="Estatus"
                                        options={catalogos.estatusSolicitud}
                                        value={campos.estatus}
                                        onChange={cambioEstatusSeleccionado}
                                        optionSelected={{ id: 'id', label: 'nestatus' }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <AutocompleteForm
                                        label="Gerencia"
                                        options={getGerencias(campos.sistema?.requerimientos || [])}
                                        value={campos.gerencia}
                                        onChange={gerencia => setCampos({ ...campos, gerencia: gerencia})}
                                        optionSelected={{ id: 'responsable', label: 'nresponsable' }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                />
                <Grid container spacing={2} className={classes.containerRequerimientos}>
                    <Grid item xs={2}>
                        <MenuSistemas
                            label="Sistemas"
                            options={catalogos.sistemas}
                            disable={btnTdxs}
                            optionSelected={{
                                id: 'idproyecto',
                                label: 'nproyecto'
                            }}
                            value={campos.sistema}
                            onChange={cambioProyectoSeleccionado}
                        />
                    </Grid>
                    <Grid item xs={10}>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 15]}
                            component="div"
                            count={solicitudesFiltradas.length}
                            rowsPerPage={paginacion.rowPage}
                            page={paginacion.page}
                            onPageChange={(event, page) => setPaginacion({ ...paginacion, page })}
                            onRowsPerPageChange={event => setPaginacion({ page: 0, rowPage: event.target.value })}
                            labelRowsPerPage="Resultados por página"
                        />
                        {solicitudesFiltradas.length ? (
                            solicitudesFiltradas
                                .slice(paginacion.page * paginacion.rowPage, paginacion.rowPage * (paginacion.page + 1))
                                .map(sol => (
                                    <Accordion
                                        key={sol.idsolicitud}
                                        expanded={solicitudSeleccionada?.idsolicitud === sol.idsolicitud}
                                        onChange={handleChange(sol)}
                                    >
                                        <AccordionSummary expandIcon={<ExpandMore />}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={4}>
                                                    <Typography
                                                        className={classes.heading}
                                                        display="inline"
                                                        style={{ fontSize: 14, fontWeight: 600 }}
                                                    >
                                                        {sol.titulo}
                                                    </Typography>
                                                </Grid>
                                                <Grid container item xs={3}>
                                                    <Typography className={classes.heading} display="inline" variant="caption">
                                                        #Tareas: {sol.nTareas}
                                                    </Typography>
                                                    &nbsp; &nbsp;
                                                    <Typography className={classes.heading} display="inline" variant="caption">
                                                        #Modificaciones de alcance: {sol.numMAlcance}
                                                    </Typography>
                                                    &nbsp; &nbsp;
                                                    <Typography className={classes.heading} display="inline" variant="caption">
                                                        Horas propuestas: &nbsp;
                                                        <NumberFormat value={sol.nhoras} decimalScale={0} suffix="" displayType="text" />
                                                    </Typography>
                                                </Grid>
                                                <Grid item container xs={3}>
                                                    <Tooltip title="Fecha inicio">
                                                        <span>
                                                            <SvgIcon component={cdesde} viewBox="0 0 42 42" />
                                                        </span>
                                                    </Tooltip>
                                                    <Typography className={classes.heading} display="inline" variant="caption">
                                                        {sol.fecha_inicio != null ? format(sol.fecha_inicio) : 'N/A'}
                                                    </Typography>
                                                    &nbsp; &nbsp;
                                                    <Tooltip title="Fecha fin">
                                                        <span>
                                                            <SvgIcon component={chasta} viewBox="0 0 42 42" />
                                                        </span>
                                                    </Tooltip>
                                                    <Typography className={classes.heading} display="inline" variant="caption">
                                                        {sol.fecha_fin != null ? format(sol.fecha_fin) : 'N/A'}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Chip
                                                        size="small"
                                                        label={
                                                            <Typography className={classes.heading} display="inline" variant="caption">
                                                                {sol.nestatus}
                                                            </Typography>
                                                        }
                                                        className={sol.idestatus == 5 ? classes.fin : sol.idestatus == 4 ? classes.des : ''}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Container>
                                                <Tabla columnKey="idtipo" columns={columns} rows={sol.tareas || []} />
                                            </Container>
                                        </AccordionDetails>
                                    </Accordion>
                                ))
                        ) : (
                            <Card>
                                <CardContent>
                                    <Typography variant="h4" align="center">
                                        {campos.sistema?.requerimientos
                                            ? 'No se encontraron requerimientos para el sistema'
                                            : 'No hay proyecto seleccionado'}
                                    </Typography>
                                </CardContent>
                            </Card>
                        )}
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
};
const estatusSolicitud = [
    {
        id: '4,8',
        nestatus: 'EN DESARROLLO'
    },
    {
        id: '5,8',
        nestatus: 'FINALIZADA'
    }
];
export default TareasXrequerimientos;
